export function isMobileDevice() {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';
  const isMobileUa = /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
  const isTouchDevice = navigator.maxTouchPoints > 1 && window.innerWidth < 1024;

  return isMobileUa || isTouchDevice;
}

export function normalizePhoneForWhatsApp(phone) {
  if (!phone) return null;

  let numero = String(phone).replace(/\D/g, '');
  if (!numero) return null;

  if (numero.startsWith('0')) {
    numero = numero.substring(1);
  }
  if (!numero.startsWith('54')) {
    numero = '54' + numero;
  }

  return numero;
}

export function buildWhatsAppUrl(phone, message) {
  const numero = normalizePhoneForWhatsApp(phone);
  const encodedMessage = encodeURIComponent(message);

  if (isMobileDevice()) {
    return numero
      ? `https://wa.me/${numero}?text=${encodedMessage}`
      : `https://wa.me/?text=${encodedMessage}`;
  }

  return numero
    ? `https://web.whatsapp.com/send?phone=${numero}&text=${encodedMessage}`
    : `https://web.whatsapp.com/send?text=${encodedMessage}`;
}

export function openWhatsAppChat(phone, message) {
  const url = buildWhatsAppUrl(phone, message);

  if (isMobileDevice()) {
    window.location.href = url;
    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}
